<template>
	<v-app-bar color="transparent" flat>
		<img
			class="mr-2 logo"
			src="@/assets/images/logo.svg"
			alt="JaviCo Logo"
		/>
		<v-app-bar-title class="white--text font-weight-bold">
			JaviCo
		</v-app-bar-title>
		<v-spacer />

		<!-- Desktop -->
		<div v-if="windowSize.width >= 600">
			<v-tabs
				v-model="routeModel"
				class="text-shadow"
				background-color="transparent"
				center-active
				fixed-tabs
				dark
			>
				<v-tabs-slider
					class="slider-glow"
					:color="barColor"
				/>

				<v-tab
					v-for="(routeName, index) in routesNames"
					:key="index"
					@click="goToRouteByName(routeName)"
				>
					<h4>{{ routeName }}</h4>
				</v-tab>
			</v-tabs>
		</div>

		<!-- Mobile -->
		<v-menu
			v-else
			offset-y
			dark
		>
			<template v-slot:activator="{ on, attrs }">
				<v-btn
					v-bind="attrs"
					v-on="on"
					color="white"
					icon
				>
					<v-icon>mdi-dots-vertical</v-icon>
				</v-btn>
			</template>
			<v-list min-width="125">
				<v-list-item-group
					v-model="routeModel"
					:color="barColor"
					mandatory
				>
					<v-list-item
						v-for="(routeName, index) in routesNames"
						:key="index"
						@click="goToRouteByName(routeName)"
					>
						<v-list-item-title
							:class="index==routeModel ? 'font-weight-bold' : ''"
						>
							{{ routeName }}
						</v-list-item-title>
					</v-list-item>
				</v-list-item-group>
			</v-list>
		</v-menu>
	</v-app-bar>
</template>

<script>
export default {
	name: "AppbarItem",
	props:{
		barColor: {
			type: String,
			default: "white"
		},
		windowSize: {
			type: Object,
			required: true
		}
	},
	data: () => ({
		routeModel: 0,
		routesNames: ["Home", "Portfolio", "Contact"],
	}),
	created() {
		this.getRouteModel()
	},
	methods: {
		getRouteModel() {
			this.routeModel = this.routesNames.findIndex(
				element => element == this.$route.name
			)
		},
		goToRouteByName(selectedRouteName) {
			if(selectedRouteName != this.$route.name){
				this.$router.push({ name: selectedRouteName })
			}
		}
	}
};
</script>

<style scoped>
.slider-glow {
	filter: drop-shadow(0 0 4px white);
}
.logo {
	width: 30px;
}
.text-shadow {
	text-shadow: 2px 2px 4px black;
}
</style>